<app-header></app-header>

<div *ngIf="dashboard" class="dashboard-body" [class.editing]="editing" (contextmenu)="onContextMenu($event)">
    <app-animated-bg></app-animated-bg>
    <div class="widgets">

        <div *ngIf="editing" class="edit-banner">
            <div class="edit-title">
                <div class="edit-heading">Editing {{editing.label}}</div>
                <div class="edit-hint">Drag a section by its title to reorder sections. Drag tiles to rearrange them or move them into another section.</div>
            </div>
            <div class="edit-actions">
                <div *ngIf="editHasLayout" class="button" (click)="resetEdit()">Reset to Default</div>
                <div class="button" (click)="cancelEdit()">Cancel</div>
                <div class="button green" [class.disabled]="saving" (click)="saveEdit()">Save</div>
            </div>
        </div>

        <div class="categories" [dragula]="'dashboard-categories'" [(dragulaModel)]="dashboard.categories">
        <div *ngFor="let category of dashboard.categories" class="category">
            <div class="category-name">{{category.name}}</div>
            <div class="category-elements" [class.is-empty]="category.elements.length === 0"
                [dragula]="'dashboard-elements'" [(dragulaModel)]="category.elements">
                <div *ngFor="let element of category.elements" class="element"
                     [class.widget-kpi]="element.type == 'widget' && element.widgetType != 'kpiTable'"
                     [class.widget-table]="element.type == 'widget' && element.widgetType == 'kpiTable'">

                    <app-dashboard-widget *ngIf="element.type == 'widget'" [element]="element" [editing]="!!editing"></app-dashboard-widget>

                    <div *ngIf="element.type == 'reportLink'" class="element-report-link" (click)="loadReportWithContext(element)">
                        <div [innerHTML]="element.icon | rf:'safeHtml'" class="icon"></div>
                        <div class="icon-label">{{element.name}}</div>
                    </div>

                    <div *ngIf="element.type == 'transferLink'" class="element-report-link" (click)="startTransfer(element)">
                        <div [innerHTML]="element.icon | rf:'safeHtml'" class="icon"></div>
                        <div class="icon-label">{{element.name}}</div>
                    </div>

                    <div *ngIf="element.type == 'vtLink'" class="element-report-link" (click)="startVT(element)">
                        <div [innerHTML]="element.icon | rf:'safeHtml'" class="icon"></div>
                        <div class="icon-label">{{element.name}}</div>
                    </div>

                    <div *ngIf="element.type == 'screenLink'" class="element-report-link" (click)="openScreen(element)">
                        <div [innerHTML]="element.icon | rf:'safeHtml'" class="icon"></div>
                        <div class="icon-label">{{element.name}}</div>
                    </div>
                    
                </div>
            </div>
        </div>
        </div>

    </div>

    <div *ngIf="contextMenu" class="context-menu" [style.left.px]="contextMenu.x" [style.top.px]="contextMenu.y"
        (click)="$event.stopPropagation()" (contextmenu)="$event.preventDefault()">
        <a (click)="startEdit('user')">Edit Dashboard</a>
        <ng-container *ngIf="isAdmin">
            <div class="menu-divider"></div>
            <a (click)="chooseGroupDefault()">Edit Group Default&hellip;</a>
            <a (click)="startEdit('global')">Edit Global Default</a>
        </ng-container>
    </div>

    <app-support *ngIf="supportActive"></app-support>
    <app-settings *ngIf="settingsActive"></app-settings>
</div>